// import useNotificationsStore from '../stores/notifications.store';

const handleError = (error) => {
  // const snackbarStore = useNotificationsStore();
  let message;

  // if (!error) {
  //   message = 'Error desconocido';
  //   snackbarStore.showSnackbar(message, 'error');
  //   return;
  // }

  switch (error.code) {
    case 'ECONNABORTED':
      message = 'El servidor no responde';
      break;
    case 'ECONNRESET':
      message = 'El servidor no responde';
      break;
    case 'ERR_NETWORK':
      message = 'No fue posible conectar con el servidor';
      break;
    case 'ERR_BAD_REQUEST':
      message = 'Error el cuerpo de la solicitud';
      break;
    case 'ERR_BAD_RESPONSE':
      message = 'El servidor respondió de manera inesperada';
      break;
    default:
      message = `Error desconocido: ${error.message}`;
  }

  console.log(message);
  // snackbarStore.showSnackbar(message, 'error');
};

export default handleError;
